import React, { useState } from "react";
import "./OptInPage.css";

export default function OptInPage() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="optin-page">
      <h2>Opt-In Disclosure</h2>
      <p>
        By signing up on this site, you agree to receive SMS communications from <strong>LEXTRACKAI CORP</strong> at the number you provided.
        Msg & data rates may apply. Reply STOP to unsubscribe at any time.
      </p>

      <form onSubmit={handleSubmit}>
        <div className="optin-form-wrapper">
          <label htmlFor="phone">
            Phone Number:
            <input id="phone" type="tel" required placeholder="Enter your phone number" />
          </label>

          <label className="checkbox-wrapper">
            <input type="checkbox" required />
            I agree to receive SMS messages from LEXTRACKAI CORP.
          </label>

          <button type="submit">Submit</button>

          {submitted && (
            <p className="success-message">
              ✅ Thank you! Your consent has been recorded.
            </p>
          )}
        </div>
      </form>
    </div>
  );
}
